'use strict';

import { clearCart, addToCart } from './cart-api.js';

const buttons = document.querySelectorAll("button[data-add-to-cart-discount]");
const cartAttributes = { _cart_started_as: window.customerType, 
                        user_type: window.user_type 
                       };

buttons.forEach(function(button) {
    button.addEventListener("click", function(e) {
        e.preventDefault();

        if (button.classList.contains('add-disabled')) return;
        buttons.forEach(function(addButton) { addButton.classList.add("add-disabled"); } );

        const form = e.currentTarget.closest("form");
        let redirectUrl = '';
        const discountUrl = button.getAttribute("data-discount-url");
        if (discountUrl) {
          redirectUrl = discountUrl + '?redirect=%2Fcart';
        }
        else{
          redirectUrl = '/cart';
        }

        try {
            const entries = Object.fromEntries(new FormData(form));
            const props = {
              id: entries.id,
              title: entries.title,
              quantity: 1
            };

            addToCart(props, cartAttributes)
              .then((response) => {
                window.location.href = redirectUrl;
              })
              .catch((error) => {
                console.error('Error adding bundle to the cart:', error);
              });

        } catch (error) {
            console.log(error, 'Something went wrong!');
            button.classList.remove("add-disabled");
        }
    });
    button.removeAttribute("disabled");
});
